//本地存储变化
export default function dispatchEventStroage() {
  const signSetItem = localStorage.setItem;
  localStorage.setItem = function(key, val) {
    let setEvent = new Event("setItemEvent");
    setEvent.key = key;
    setEvent.newValue = val;
    window.dispatchEvent(setEvent);
    signSetItem.apply(this, arguments);
  };
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/localstorage.js
// module id = null
// module chunks = 